import type { AppSpinButtonProps } from "./AppSpinButton.Props";

export const isAppSpinButtonProps = (props: {
  type: string;
}): props is AppSpinButtonProps => {
  return (props as AppSpinButtonProps).type === "AppSpinButtonProps";
};
